import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { PageSettings } from '../../config/page-settings.js';
import Stepper from '../../components/Stepper';
import StepContainer from './components/StepContainer';
import Step1 from './components/Step1';
import Step2 from './components/Step2';
import Step3 from './components/Step3';
import Step4 from './components/Step4';

const Register = () => {
  const context = useContext(PageSettings);
  const history = useHistory();
  
  // State for multi-step
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    nombre: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    email: '',
    telefono: '',
    password: '',
    confirmPassword: '',
    // Step 2 fields
    organizacionNombre: '',
    organizacionRFC: '',
    organizacionTipoEntidad: '',
    organizacionDireccion: '',
    organizacionEstado: '',
    organizacionPais: '',
    organizacionTelefono: '',
    organizacionLogotipo: null,
    // Step 3 fields
    configProducto: '',
    configCertificaciones: [],
    configModulos: [],
    configPrivacidadTerminos: false
  });
  
  // State for UI toggles
  const [typePassword, setTypePassword] = useState('password');
  const [typeConfirm, setTypeConfirm] = useState('password');

  useEffect(() => {
    // Esconder configuración del layout
    context.handleSetPageSidebar(false);
    context.handleSetPageHeader(false);
    context.handleSetBodyWhiteBg(false);

    return () => {
      // Restaurar al salir
      context.handleSetPageSidebar(true);
      context.handleSetPageHeader(true);
      context.handleSetBodyWhiteBg(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (fieldName, value) => {
    setFormData(prev => {
      const currentValues = prev[fieldName] || [];
      const newValues = currentValues.includes(value)
        ? currentValues.filter(v => v !== value)
        : [...currentValues, value];
      return { ...prev, [fieldName]: newValues };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(`Datos de registro paso ${currentStep}:`, formData);
    
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    } else {
      // Final submission (Step 4 is the last for now)
      console.log("Registro completo:", formData);
    }
  };

  const togglePassword = () => setTypePassword(prev => prev === 'password' ? 'text' : 'password');
  const toggleConfirm = () => setTypeConfirm(prev => prev === 'password' ? 'text' : 'password');

  const steps = [
    {
      id: 1,
      title: 'Registro de Administrador',
      subtitle: 'Crea tu identidad personal para gestionar tu cooperativa o empresa.',
      component: Step1
    },
    {
      id: 2,
      title: 'Datos de tu Organización',
      subtitle: 'Configura la identidad y ubicación de tu cooperativa o empresa.',
      component: Step2
    },
    {
      id: 3,
      title: 'Configuración Inicial',
      subtitle: 'Define el producto principal, parámetros de operación y los módulos de trabajo.',
      component: Step3,
      buttonText: 'Finalizar',
      buttonClass: 'btn-warning text-white fw-bold'
    },
    {
      id: 4,
      // title: 'Todo listo',
      // subtitle: 'Define el producto principal, parámetros de operación y los módulos de trabajo.',
      component: Step4,
      buttonText: 'Finalizar',
      buttonClass: 'btn-warning text-white fw-bold'
    }
  ];

  const currentStepData = steps[currentStep - 1] || steps[0];
  const CurrentStepComponent = currentStepData.component;

  return (
    <div className="login p-0" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem' }}>
      <div className="card shadow-sm border-0" style={{ width: '100%', maxWidth: '900px', borderRadius: '15px' }}>
        <div className="card-body p-sm-5 p-32">
          
          <Stepper currentStep={currentStep} totalSteps={steps.length} />

          <StepContainer
            currentStep={currentStep}
            totalSteps={steps.length}
            title={currentStepData.title}
            subtitle={currentStepData.subtitle}
            onSubmit={handleSubmit}
            buttonText={currentStepData.buttonText}
            buttonClass={currentStepData.buttonClass}
          >
            <CurrentStepComponent
              formData={formData}
              handleChange={handleChange}
              handleCheckboxChange={handleCheckboxChange}
              togglePassword={togglePassword}
              toggleConfirm={toggleConfirm}
              typePassword={typePassword}
              typeConfirm={typeConfirm}
            />
          </StepContainer>

        </div>
      </div>
    </div>
  );
};

export default Register;